module.exports = __webpack_public_path__ + "img/cannery-hall.1001d42f.jpg";